import axios from "axios";

const urlPath = "propertie";

export const getServiciosFincas = async () => {
  try {
    const response = await axios.get(`${urlPath}/services`);

    return response.data;
  } catch (err) {
    console.log(err.response);
  }
};
export const getFincas = async () => {
  try {
    const response = await axios.get(urlPath);

    return response.data;
  } catch (err) {
    console.log(err.response);
  }
};
export const getFincaDocsSupp = async (nif) => {
  try {
    const response = await axios.get(`${urlPath}/propDocsSupp/${nif}`);

    return response.data;
  } catch (err) {
    console.log(err.response);
  }
};
export const getFinca = async (nif) => {
  try {
    const response = await axios.get(`${urlPath}/${nif}`);

    return response.data;
  } catch (err) {
    console.log(err.response);
  }
};

export const getFincasUnAAFF = async (data) => {
  try {
    const response = await axios.post(`${urlPath}/allPropsOneAAFF`, data);

    return response.data;
  } catch (err) {
    console.log(err.response);
  }
};
export const getFincasInforme = async (data) => {
  try {
    const response = await axios.post(`${urlPath}/allPropertiesInforme`, data);

    return response.data;
  } catch (err) {
    console.log(err.response);
  }
};
export const getFincasSinProv = async (data) => {
  try {
    const response = await axios.post(`${urlPath}/allPropertiesNoSupp`, data);
    return response.data;
  } catch (err) {
    console.log(err.response);
  }
};
// Facturas impagadas (en vivo desde la az-function) de una comunidad, para el modal
export const getImpagosComunidad = async (nif) => {
  try {
    const response = await axios.get(`${urlPath}/impagos/${nif}`);
    return response.data;
  } catch (err) {
    console.log(err.response || err);
    throw err;
  }
};
// Informes > Abonos: lista de filas del excel de impagos que coinciden con comunidades/ventas
export const getAbonosImpagos = async () => {
  try {
    const response = await axios.get(`${urlPath}/impagos-abonos/lista`);
    return response.data;
  } catch (err) {
    console.log(err.response || err);
    throw err;
  }
};
// Sincronizar: marca como impagadas las ventas seleccionadas
export const sincronizarImpagados = async (saleIds) => {
  try {
    const response = await axios.post(`${urlPath}/impagos-abonos/sincronizar`, { saleIds });
    return response.data;
  } catch (err) {
    console.log(err.response || err);
    throw err;
  }
};
export const getListFincas = async (data) => {
  console.log(data)
  try {
    const response = await axios.post(`${urlPath}/filterAllProps`, data.filtros, {
      params: data.params,
      signal: data.signal
    });

    return response.data;
  } catch (err) {
    if (axios.isCancel && axios.isCancel(err)) {
      return;
    }
    if (err.name === 'CanceledError') {
      return;
    }
    console.log(err.response || err);
    throw err;
  }
};
export const getListFincasToExport = async (data) => {
  try {
    const response = await axios.post(
      `${urlPath}/exportExcel`,
      data.filtros,
      {
        params: data.params,
        signal: data.signal,
        responseType: 'blob', // Ahora Axios sí lo reconocerá
        headers: {
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      }
    );

    return response.data;
  } catch (err) {
    if (axios.isCancel && axios.isCancel(err)) {
      return;
    }
    if (err.name === 'CanceledError') {
      return;
    }
    console.log(err.response || err);
    throw err;
  }
};

export const getFincasAAFF = async (data) => {
  try {
    const response = await axios.post(`${urlPath}/filter`, data.filtros, {
      params: data.params,
    });


    return response.data;
  } catch (err) {
    console.log(err.response || err);
    throw err;
  }
};
export const getTodasFincasTech = async (data) => {

  console.log("data", data.filtros);
  try {
    const response = await axios.post(`${urlPath}/allProps/${data.filtros.aaff_id}`, data.filtros, {
      params: data.params,
    });

    return response.data;
  } catch (err) {
    console.log(err.response);
  }
};
export const getFincasTech = async (data) => {
  try {
    const response = await axios.post(`${urlPath}/PropertiesTech`, data.filtros, {
      params: data.params,
    });

    return response.data;
  } catch (err) {
    console.log(err.response);
  }
};

export const getSuppListPropertiAaff = async (data) => {
  try {
    const response = await axios.post(`${urlPath}/filterAllProps`, data.filtros, {
      params: data.params,
    });
    return response.data;
  } catch (err) {
    console.log(err.response);
  }
};

export const AaffListPropertie = async (data) => {
  try {
    const response = await axios.post(`${urlPath}/AaffListPropertie`, data.filtros, {
      params: data.params,
    });

    return response.data;
  } catch (err) {
    console.log(err.response);
  }
};

export const AaffListPropertieExport = async (data) => {
  try {
    const response = await axios.post(`${urlPath}/AaffListPropertieExport`, data.filtros, {
      params: data.params,
    });

    return response.data;
  } catch (err) {
    console.log(err.response);
  }
};

export const deleteFinca = async (nif) => {
  try {
    const response = await axios.delete(`${urlPath}/${nif}`);

    return response.data;
  } catch (err) {
    console.log(err.response);
  }
};
export const deleteFincasAAFF = async (nif) => {
  try {
    const response = await axios.delete(`${urlPath}/aaff/${nif}`);

    return response.data;
  } catch (err) {
    console.log(err.response);
  }
};
export const cambiarFinca = async (nif, data) => {
  console.log("nif", nif);
  try {
    const response = await axios.put(`${urlPath}/${nif}`, data);
    return response;
  } catch (err) {
    console.log(err);
    return err;
  }
};
export const renovarFinca = async (nif) => {
  const data = {
    renovada: true,
    pendiente: false,
    fechaRenovacion: new Date(),
  };
  try {
    const response = await axios.put(`${urlPath}/${nif}`, data);

    return response.data;
  } catch (err) {
    console.log(err.response);
  }
};

export const deleteMatchFincaProv = async (idFinca, idProveedor, aaff_id) => {
  let datos = {
    prop_id: idFinca,
    supp_id: idProveedor,
    aaff_id: aaff_id
  };

  try {
    const response = await axios.post(`${urlPath}/delete/matchSupp`, datos);

    return response;
  } catch (err) {
    console.log(err.response);
  }
};
export const getListarDocsFincaProv = async (sale_id) => {
  try {
    const response = await axios.get(`docsProps/listDocs/${sale_id}`);
    return response.data;
  } catch (err) {
    console.log(err.response);
    return err.response;
  }
};

export const guardarFechaDocLeido = async (doc_id, supp_id) => {
  try {
    const response = await axios.post(`docsProps/read-doc/${doc_id}`, supp_id);

    return response.data;
  } catch (err) {
    console.log(err.response);
  }
};

export const renovacionFincasAAFF = async (data) => {

  try {
    const response = await axios.post(`sale/renovate-sales-aaff`, data);
    return response.data;
  } catch (err) {
    console.log(err.response);
    return err.response;
  }
};

export const getPortales = async (id) => {
  try {
    console.log(id)
    const response = await axios.get(`${urlPath}/portales/${id}`);

    return response.data;
  } catch (err) {
    console.log(err.response);
  }
};

export const reasignarFincasAAFF = async (data) => {
  try {
    const response = await axios.put(`${urlPath}/reasignarFincas`, data);
    return response;
  } catch (err) {
    console.log(err.response);
    return err.response;
  }
};
export const reasignarServicio = async (data) => {
  console.log(data)
  try {
    const response = await axios.put(`${urlPath}/reasignarServicio`, data);
    return response;
  } catch (err) {
    console.log(err.response);
    return err.response;
  }
};